import React, { useState } from 'react';

const PRESETS = [
  { label: 'Tümü', value: 'all' },
  { label: 'Bu Ay', value: 'this_month' },
  { label: 'Son 3 Ay', value: 'last_3' },
  { label: 'Son 6 Ay', value: 'last_6' },
  { label: 'Bu Yıl', value: 'this_year' },
  { label: 'Geçen Yıl', value: 'last_year' },
  { label: 'Tarih Aralığı', value: 'custom' },
];

export default function DateFilter({ onFilter }) {
  const [preset, setPreset] = useState('all');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const apply = () => {
    const now = new Date();
    const params = {};

    switch (preset) {
      case 'this_month':
        params.period = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        break;
      case 'last_3': {
        const d = new Date(now); d.setMonth(d.getMonth() - 3);
        params.from = d.toISOString().slice(0, 10);
        params.to = now.toISOString().slice(0, 10);
        break;
      }
      case 'last_6': {
        const d = new Date(now); d.setMonth(d.getMonth() - 6);
        params.from = d.toISOString().slice(0, 10);
        params.to = now.toISOString().slice(0, 10);
        break;
      }
      case 'this_year':
        params.year = String(now.getFullYear());
        break;
      case 'last_year':
        params.year = String(now.getFullYear() - 1);
        break;
      case 'custom':
        if (from) params.from = from;
        if (to) params.to = to;
        break;
      default:
        break;
    }
    onFilter(params);
  };

  return (
    <div className="filter-bar">
      <select value={preset} onChange={e => setPreset(e.target.value)}>
        {PRESETS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
      </select>
      {preset === 'custom' && (
        <>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
          <span style={{ color: '#9ca3af' }}>—</span>
          <input type="date" value={to} onChange={e => setTo(e.target.value)} />
        </>
      )}
      <button className="btn-filter" onClick={apply}>Filtrele</button>
    </div>
  );
}
